<template>
    <div v-if="dashboard">
        <!-- Status -->
      <StatusFormacao
          @visualizar-listagem="openDialogListarStatusFormacao(null)"
          :status-list = "dashboard?.statusFormacao"
          :data-hora-info="dashboard?.dataHoraInfo"
      />

      <!-- Cards -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="pa-4 text-center">
            <div class="subtitle-2 mb-2 font-weight-medium">Carga Horária Ofertada</div>
            <div class="display-1 font-weight-bold mb-9">{{ dashboard?.info?.cargaHorariaOfertada ?? 0 }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="pa-4 text-center">
            <div class="subtitle-2 mb-2 font-weight-medium">Média De Avaliação</div>
            <div class="display-1 font-weight-bold mb-9">{{ dashboard?.info?.mediaAvaliacao ?? 0 }}%</div>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="fill-height d-flex flex-column justify-center align-center" >
            <div>Formações Realizadas</div>
            <div class="d-flex justify-center align-center mt-2">
              <div class="display-1 font-weight-bold mr-3">{{ dashboard?.info?.formacoesRealizadas ?? 0}}</div>
              <v-icon large color="green">mdi-checkbox-marked-outline</v-icon>
            </div>
            <v-btn outlined small color="green" @click="openDialogListarFormacoes">Visualizar Listagem</v-btn>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="fill-height d-flex flex-column justify-center align-center" >
            <div>Participantes</div>
            <div class="d-flex justify-center align-center mt-2">
              <div class="display-1 font-weight-bold mr-3">{{ dashboard?.info?.participantes ?? 0}}</div>
              <v-icon large color="blue">mdi-account-group-outline</v-icon>
            </div>
            <v-btn outlined small color="blue" @click="openDialogListarParticipantes">Visualizar Listagem</v-btn>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="fill-height d-flex flex-column justify-center align-center" >
            <div>Participação</div>
            <div class="d-flex justify-center align-center mt-2">
              <div class="display-1 font-weight-bold mr-3">{{ dashboard?.info?.participacao ?? 0}} %</div>
              <v-icon large color="green">mdi-chart-pie</v-icon>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Gráficos -->
      <v-row>
        <v-col cols="12" md="12" class="fill-height" style="height: 500px;">
          <v-card class="pa-4 text-center fill-height" style="height: 100%;">
            <div class="mb-4 text-start ">Formações</div>
            <PieChart v-if="dataPizza?.labels.length > 0" :chartData="dataPizza" />
            <p v-else style="color: #333;">Não há dados!</p>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="fill-height">
          <v-card class="pa-4 text-center fill-height" style="height: 100%">
            <HorizontalBarStackedChart v-if="stackedChartData" :rawData="stackedChartData"  :height="stackedChartHeight"/>
            <p v-else style="color: #333;">Não há dados!</p>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="btn-group">
        <v-col class="text-end">
          <v-btn
              color="primary"
              @click="exportarDadosPdf"
              outlined
          >
            Exportar Gráficos
          </v-btn>
        </v-col>
      </v-row>
      <!-- Dialogs -->
    <ListarFormacaoPorStatusDialog
      v-if="dialogListarFormacaoStatus.visible"
      :visible="dialogListarFormacaoStatus.visible"
      :content="dialogListarFormacaoStatus.content"
      @onClose="dialogListarFormacaoStatus.close()"
    ></ListarFormacaoPorStatusDialog>

    <ListarFormacoesDialog
        v-if="dialogListarFormacoes.visible"
        :visible="dialogListarFormacoes.visible"
        :content="dialogListarFormacoes.content"
        @onClose="dialogListarFormacoes.close()"
    ></ListarFormacoesDialog>

    <ListarParticipantesDialog
        v-if="dialogListarParticipantes.visible"
        :visible="dialogListarParticipantes.visible"
        :content="dialogListarParticipantes.content"
        @onClose="dialogListarParticipantes.close()"
    ></ListarParticipantesDialog>
    </div>
</template>

<script>
import {Dialog} from "commons/classes/dialog";
import {Dashboard} from "commons/classes/dashboard";
import DashboardFormacaoService from "services/dashboard-formacao.service";
import ListarFormacaoPorStatusDialog from "../../dialogs/GRE/ListarFormacaoPorStatusDialog.vue";
import ListarFormacoesDialog from "../../dialogs/GRE/ListarFormacoesDialog.vue";
import ListarParticipantesDialog
  from "~/views/post-login/administrador/manter-dashboard-formacao/dialogs/GRE/ListarParticipantesDialog.vue";
export default {
  name: "ManterDashboardFormacaoEscolaUnicaView",
  props: {
    dashboardEscolaUnica: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [DashboardFormacaoService],
  components: {
    StatusFormacao: () => import('../../components/StatusFormacao.vue'),
    PieChart: () => import('@/components/Graficos/PieChart.vue'),
    HorizontalBarStackedChart: () => import('@/components/Graficos/HorizontalBarStackedChart'),
    //dialogs
    ListarFormacaoPorStatusDialog,
    ListarFormacoesDialog,
    ListarParticipantesDialog,
  },
  data: () => ({
    dialogListarFormacaoStatus: Dialog.Build(),
    dialogListarFormacoes: Dialog.Build(),
    dialogListarParticipantes: Dialog.Build(),
    dataPizza: null,
    stackedChartData: null,
    dashboard: null,
    form:{
      filters: {
        gre: null,
      },
      listaGerenciasRegionais: [],
    },
  }),
  methods: {
    openDialogListarStatusFormacao() {
      this.dialogListarFormacaoStatus.open(new Dashboard({
        id: this.dashboard?.greCodigo,
        origemId: 3,
        escolaCodigo: this.dashboard?.escolaCodigo
      }));
    },
    openDialogListarFormacoes() {
      this.dialogListarFormacoes.open(new Dashboard({
        id: this.dashboard.greCodigo,
         origemId: 3,
         escolaCodigo: this.dashboard?.escolaCodigo
        }));
    },
    openDialogListarParticipantes() {
      this.dialogListarParticipantes.open(new Dashboard({
        id: this.dashboard?.greCodigo,
        origemId: 3,
        escolaCodigo: this.dashboard?.escolaCodigo
      }));
    },
    async exportarDadosPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardEscolaUnicaPdf(this.$montarParamsFilters(
            {greCodigo: this.dashboard?.greCodigo, escolaCodigo: this.dashboard?.escolaCodigo}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.FormacoesEscolaUnica.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
  },
  computed: {
    stackedChartHeight() {
      return this.stackedChartData?.length > 5 ? 650 : 400;
    }
  },
  mounted() {
    this.dashboard = this.dashboardEscolaUnica;
    this.stackedChartData = this.dashboardEscolaUnica.grafico?.stackedChartData || [];
    this.dataPizza ={
      labels: this.dashboardEscolaUnica?.grafico?.labelPizza,
      datasets: [
        {
          data: this.dashboardEscolaUnica?.grafico?.dataPizza,
          backgroundColor: ['#3F51B5','#4CAF50','#F44336', '#FF9800','#9C27B0','#00BCD4','#CDDC39','#E91E63','#2196F3','#795548']
        }
      ]
    }
  },
}
</script>